<template>
      <v-app id="TreeView">
      <v-container>
      <!-- <v-select v-model="selectionType" :items="['leaf', 'independent']" label="Selection type"></v-select> -->
      <v-row>
        <v-col >
          <v-treeview
            v-model="selection"
            :items="items"
            selection-type="independent"
            selectable
            return-object
            open-all
          ></v-treeview>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col class="pa-6">
          <template v-if="!selection.length">
            Admin View
          </template>
          <template v-else>
            <div v-for="node in selection" :key="node.id">
              Id: {{ node.id}} <br>
              Name: {{ node.name }}<br>
              <template v-if="isAgency(node.name)" >
                <AgencyLevel v-bind:officeId="node.id"></AgencyLevel>

              </template>

              <template v-else-if="isProgram(node.name)">
                <v-btn rounded color="primary" small dark>Create Field</v-btn>
                <v-btn rounded color="primary" small dark>Update Program</v-btn> <br>
                <v-btn rounded color="primary" small dark>Assign Users to Program</v-btn>
              </template>

              <template v-else-if="isField(node.name)">
                <v-btn rounded color="primary" small dark>Create Branch</v-btn>
                <v-btn rounded color="primary" small dark>Update Field</v-btn> <br>
                <v-btn rounded color="primary" small dark>Assign Users to Field</v-btn>
              </template>

              <template v-else-if="isBranch(node.name)">
                <v-btn rounded color="primary" small dark>Update Branch</v-btn> <br>
                <v-btn rounded color="primary" small dark>Assign Users to Branch</v-btn>
              </template>
            </div>
          </template>
        </v-col>
      </v-row>

    </v-container>
  </v-app>
</template>

<script>
import Vue from "vue";
import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import { CONSTANTS } from "../../common/constants";
import { officeManagementService } from "../../services/officeManagementService.js";
import router from "@/router";
export default {
  name: "TreeView",
  components: {},
  data: () => ({
    selectionType: 'independent',
    selection: [],
    items: [
    ],
    fav: true,
    menu: false,
    message: false,
    hints: true
  }),
  methods: {
    logout () {
      authService.logout();
    },
    admin () {
      router.push({ name: "admin" });
    },
    isAgency (office) {
      var res = office.split("-");
      if (res[1] == "NULL") {
        return true;
      }
      return false;
    },
    isProgram (office) {
      var res = office.split("-");
      if (res[1] != "NULL" && res[2] == "NULL") {
        return true;
      }
      return false;
    },
    isField (office) {
      var res = office.split("-");
      if (res[1] != "NULL" && res[2] != "NULL" && res[3] == "NULL") {
        return true;
      }
      return false;
    },
    isBranch (office) {
      var res = office.split("-");
      if (res[1] != "NULL" && res[2] != "NULL" && res[3] != "NULL") {
        return true;
      }
      return false;
    }

  },
  mounted () {
    const me = this;
    const claims = authTokenService.getClaims();
    const s = officeManagementService
        .getFullTree()
        .then(function (response) {
          if (response && response.data) {
            me.items = response.data;
          }
        })
        .catch(function (e) {
          console.error(e);
          throw e;
        });
  }
};
</script>
